import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { config } from "../../../../config/index";
import { toWeekDaysArrayFull } from "../../../../helpers/moment";
import WeekDaySchedule from "./WeekDaySchedule";

const { API_URL } = config;

const ShiftWeekSchedule = ({
  client,
  sites,
  activeWeek,
  activeSite,
  siteShifts,
  activeDate,
  preferredShifts,
  schedules,
  setPreferredShifts,
}) => {
  const { t } = useTranslation();
  const [activeSchedules, setActiveSchedules] = useState([]);

  const getWeekDaysSites = (day) => {
    return activeSchedules
      .filter((schedule) => schedule.date === day.format("YYYY-MM-DD"))
      .map((item) => item.site)
      .filter((value, index, self) => self.indexOf(value) === index);
  };

  const getWeekDaysShifts = (day) => {
    return activeSchedules
      .filter((schedule) => schedule.date === day.format("YYYY-MM-DD"))
      .map((item) => item.shift)
      .filter((value, index, self) => self.indexOf(value) === index);
  };

  const getWeekSchedule = () => {
    if (activeWeek.startDate && client) {
      return toWeekDaysArrayFull(activeWeek.startDate, client.start_day).map(
        (day, index) => (
          <WeekDaySchedule
            key={index}
            day={day}
            getWeekDaysSites={getWeekDaysSites}
            getWeekDaysShifts={getWeekDaysShifts}
            sites={sites}
            siteShifts={siteShifts}
            preferredShifts={preferredShifts}
            activeDate={activeDate}
            activeSite={activeSite}
            config={config}
            setPreferredShifts={setPreferredShifts}
          />
        )
      );
    }
  };

  useEffect(() => {
    if (activeWeek.startDate && client) {
      let filtered = schedules.filter((schedule) => {
        return (
          moment(schedule.date, "YYYY-MM-DD") >= moment(activeWeek.startDate) &&
          moment(schedule.date, "YYYY-MM-DD") <= moment(activeWeek.endDate)
        );
      });

      setActiveSchedules(filtered);
    }
  }, [activeWeek, schedules, client]);

  return (
    <div className="dashboard__weekschedule-container">
      <div className="dashboard__weekschedule-label">
        <label style={{ width: "30%" }}>{t("Date")}</label>
        <label>{t("Time")}</label>
      </div>
      {getWeekSchedule()}
    </div>
  );
};

export default ShiftWeekSchedule;
